<template>
  <div>
    <v-card v-if="isLoading" class="common-card-log">
      <div class="d-flex flex-column align-items-center mt-8 py-6">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="15"
          color="#a076f9"
          class="mx-auto my-10"
        />
      </div>
    </v-card>
    <div v-else>
      <v-col xl="12" lg="12" md="12" sm="12" xs="12" col="12" class="py-0">
        <div>
          <span
            class="mr-3"
            style="font-size: 17px; font-weight: 500; color: #6200ea"
            >سبد خرید شما ({{ computedTotalNumber }} کالا)</span
          >
        </div>
      </v-col>
      <div v-if="isEmpty">
        <EmptyCart />
      </div>
      <div v-else>
        <BuyInformation
          :cart="cartData"
          :onClick="checkout"
          :checkoutCart="checkoutCart"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { mapGetters, mapMutations, mapState } from "vuex";
import EmptyCart from "@/views/OnlineShop/Cart/Components/EmptyCart";
import BuyInformation from "@/views/OnlineShop/Cart/Components/BuyInformation";
import { LoopingRhombusesSpinner } from "epic-spinners";

export default {
  components: {
    BuyInformation,
    EmptyCart,
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      isEmpty: false,
      cart: [],
      cartId: "",
      allData: {},
      checkoutCart: [],
    };
  },
  computed: {
    ...mapGetters(["cartItems"]),
    ...mapState({
      cartData: (state) => state.onlineShop.cart,
      isLoading: (state) => state.onlineShop.isLoading,
    }),
    computedTotalNumber() {
      return this.cartData
        .map((x) => Number(x.amount))
        .reduce((a, b) => a + b, 0)
        .toLocaleString();
    },
  },
  methods: {
    ...mapMutations(["setInCart"]),
    goToId(item) {
      let id = item.parentId ? item.parentId : item.id;
      let link = `/productdetails/${item.name.replaceAll(" ", "-")}-${item.id}`;
      window.open(link, "_blank");
    },
    closeLogin() {
      this.loginDialog = false;
      location.reload();
    },
    getShippingCost() {
      Axios.get(this.baseUrl + "/onlineShop/options/shippingCosts", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.shippingCosts = res.data;
            localStorage.setItem(
              "shippingCost",
              JSON.stringify(this.shippingCosts)
            );
          }
        })
        .catch((err) => {});
    },

    setInStorage(index) {
      this.setInCart(this.wares.details);
      localStorage.setItem("cart", JSON.stringify(this.wares.details));
      this.addLoading[index] = false;
    },

    increaseCounter(item, index) {
      this.addLoading[index] = true;
      this.reactivity = !this.reactivity;
      setTimeout(() => {
        item.amount++;
        this.setInStorage(index);
        localStorage.setItem("purchaseIsChanged", true);
        this.getSelectedWares();
      }, 500);
    },

    decreaseCounter(item, index) {
      this.addLoading[index] = true;
      this.reactivity = !this.reactivity;
      if (item.amount > 1) {
        setTimeout(() => {
          item.amount--;
          this.setInStorage(index);
          localStorage.setItem("purchaseIsChanged", true);
          this.getSelectedWares();
        }, 500);
      }
    },

    openDeleteDialog(index) {
      this.selectedWareIndex = index;
      this.deleteDialog = true;
    },

    deleteWare(index) {
      this.wares.details.splice(index, 1);
      this.setInStorage();
      this.getSelectedWares();
      localStorage.setItem("purchaseIsChanged", true);
      this.deleteDialog = false;
    },

    submitPurchase() {
      this.submitLoading = true;
      this.isCardClicked = true;

      this.wares.details.forEach((detail) => {
        delete detail.pictureId;
        delete detail.pictureUrl;
      });

      let totalCost = this.wares.details
        .map((ware) => ware.price * ware.amount)
        .reduce((a, b) => a + b, 0);

      if (totalCost == 0) {
        this.isTotalZero = true;
        this.submitLoading = false;
      } else {
        if (!localStorage.getItem("shopToken")) {
          this.loginDialog = true;
          this.submitLoading = false;
        } else {
          Axios.post(
            this.baseUrl + "/onlineShop/cart/checkout",
            {
              ...this.wares,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("shopToken"),
              },
            }
          )
            .then((res) => {
              if (res.status == 200) {
                setTimeout(() => {
                  this.submitLoading = false;
                  this.wares = res.data;
                  this.userCredit = res.data.userCredit;
                  if (!this.wares.cartIsCheckoutable) {
                    let newWares = this.wares.details;
                    if (newWares.filter((ware) => ware.priceChanged).length) {
                      this.isPriceChanged = true;
                      this.setInCart(this.wares.details);
                      this.setInStorage();
                    }
                    if (newWares.filter((ware) => ware.amountChanged).length) {
                      this.isSumChanged = true;
                      this.wares.details = this.wares.details.filter(
                        (detail) => detail.sum != 0
                      );
                      this.setInCart(this.wares.details);
                      this.setInStorage();
                    }
                  } else {
                    this.setInCart(this.wares.details);
                    this.setInStorage();
                    localStorage.setItem("userCredit", res.data.userCredit);
                    localStorage.setItem(
                      "isUserAddressCompleted",
                      res.data.isUserAddressCompleted
                    );
                    localStorage.setItem(
                      "shippingAddress",
                      JSON.stringify(res.data.shippingAddress)
                    );
                    this.$router.push("/checkout/shipping");
                  }
                }, 500);
              }
            })
            .catch((err) => {
              this.submitLoading = false;
            });
        }
      }
    },
    getSelectedWares() {
      if (this.pageLoading) {
        setTimeout(() => {
          this.pageLoading = false;
          this.wares.details = JSON.parse(localStorage.getItem("cart"));
          this.wares.itemIds = this.wares.details.map((detail) => detail.id);
          this.setInCart(this.wares.details);
          this.reactivity = !this.reactivity;
          this.previousWares = JSON.parse(localStorage.getItem("cart"));
        }, 500);
      } else {
        this.wares.details = JSON.parse(localStorage.getItem("cart"));
        this.wares.itemIds = this.wares.details.map((detail) => detail.id);
        this.setInCart(this.wares.details);
        this.reactivity = !this.reactivity;
        this.previousWares = JSON.parse(localStorage.getItem("cart"));
      }
    },

    checkout() {
      Axios.post(
        this.baseUrl + `/onlineShop/cart/checkout/${this.cartId}`,
        null,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      ).then((response) => {
        const { cartIsCheckoutable, details } = response.data;
        if (cartIsCheckoutable) {
          this.$router.push("/purchase-process");
        } else {
          let newDetail = [];
          for (const iterator of details) {
            newDetail.push({
              id: iterator.id,
              ...iterator.details,
            });
          }
          this.checkoutCart = newDetail;
        }
      });
    },
  },

  // watch: {
  //   cartItems(val) {
  //     this.wares.details = val;
  //     this.reactivity = !this.reactivity;
  //   },
  // },
  mounted() {
    if (!localStorage.getItem("shopToken")) {
      this.$router.push("/");
      this.toast("ابتدا لاگین کنید", "error");
    } else {
      this.cartId = localStorage.getItem("cartId");
      this.cart = localStorage.getItem("cart")
        ? localStorage.getItem("cart")
        : [];
      this.getCartData();
      this.$store.dispatch("getCartData", {
        cartId: this.cartId,
      });
    }
  },
};
</script>
<style lang="scss">
.stuff-image {
  position: center !important;
  background-size: cover !important;

  img {
    width: auto;
    height: 230px;
    margin: 0 auto;
    border-radius: 10px;
  }
}

.cart-card {
  border-radius: 20px !important;
  box-shadow: none !important;
}

.edit-btn {
  //   box-shadow: none !important;
  //   border-radius: 8px !important;
  border: 1px solid grey;
  //   font-size: 13px !important;
  //   font-weight: bold !important;
}

.counterWares {
  border: 1px solid #ef6c00;
  border-radius: 8px;
  width: 110px;
  height: 35px;
  padding: 0 5px;

  .count {
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
  }

  .add-btn {
    margin-top: 1px;

    .v-icon {
      font-size: 1.2rem;
    }
  }
}

.emptyBasket {
  width: 25%;
}

.changedCard {
  background-color: #ef6c00 !important;
}
</style>
